
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import DemoMockup from "@/components/site/DemoMockup";

export default function Hero() {
  return (
    <section className="relative overflow-hidden pt-24 pb-14 sm:pt-30 sm:pb-18 lg:pt-36 lg:pb-24">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-12 grid lg:grid-cols-12 gap-9 lg:gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7"
        >
          <div className="inline-flex max-w-full items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1 text-xs text-zinc-300 mb-5 sm:mb-6">
            <span className="h-1.5 w-1.5 rounded-full bg-[#00E5FF] animate-pulse flex-shrink-0" />
            <span className="label-caps !text-[9px] min-[380px]:!text-[10px] !tracking-[0.16em] min-[380px]:!tracking-[0.2em] !text-zinc-300 whitespace-nowrap">
              Helping Restaurants Grow Online
            </span>
          </div>

          <h1 className="font-display font-semibold tracking-tight text-[31px] leading-[1.02] min-[360px]:text-[33px] min-[390px]:text-[35px] sm:text-5xl lg:text-6xl sm:leading-[1.02] max-w-[18ch] sm:max-w-[19ch]">
            <span className="sm:hidden">
              <span className="block text-white">Turn Restaurant Followers</span>
              <span className="block text-[#00E5FF] mt-1">
                Into Paying Customers.
              </span>
            </span>

            <span className="hidden sm:block">
              Turn Restaurant Followers Into
              <br />
              <span className="text-[#00E5FF]">Paying Customers.</span>
            </span>
          </h1>

          <p className="mt-5 sm:mt-6 text-[15px] sm:text-base md:text-lg text-zinc-400 max-w-xl leading-[1.62] sm:leading-relaxed">
            TapToTable gives your restaurant one focused page to promote
            special offers, upcoming events, and featured menu items.
            Showcase your best dishes without needing discounts or claim codes.
            Give customers easy access to your menu, reservations, directions,
            and other next steps. We build your page first. You review it
            before paying, then update it anytime from your dashboard.
          </p>

          <div className="mt-5 flex w-full max-w-xl flex-wrap items-center rounded-2xl border border-[#00E5FF]/30 bg-[#00E5FF]/10 px-4 py-3 text-sm text-zinc-100 sm:inline-flex sm:w-auto">
            <strong className="text-white">$59/month</strong>
            <span className="mx-2 text-zinc-400">•</span>
            <span>
              Hosting, customer activity, supported analytics, updates, and
              support included.
            </span>
          </div>

          <div className="mt-7 sm:mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/signup"
              className="pulse-ring inline-flex justify-center items-center gap-2 bg-[#00E5FF] text-black font-semibold px-6 py-3.5 rounded-full hover:bg-[#66FFFF] transition-all"
            >
              Build My TapToTable Page
            </Link>

            <a
              href="#pricing"
              className="inline-flex justify-center items-center gap-2 bg-white/5 text-white font-semibold px-6 py-3.5 rounded-full border border-white/10 hover:bg-white/10 transition-all"
            >
              View Pricing
            </a>
          </div>

          <div className="mt-8 sm:mt-10 grid sm:grid-cols-3 gap-3 text-xs text-zinc-400 max-w-xl">
            <div>✓ Built for your restaurant</div>
            <div>✓ Promotions, Events &amp; Featured Items</div>
            <div>✓ No technical skills required</div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 flex justify-center"
        >
          <DemoMockup />
        </motion.div>
      </div>
    </section>
  );
}
